import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/linerichmenustat",
    name: "LineRichmenuStat",
    component: () =>
      import(/* webpackChunkName: "LineRichmenuStat" */ "../views/LineRichmenuStat.vue"),
  },
  {
    path: "*",
    redirect: '/'
    
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
